var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumpadDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 40,
    viewBox: "0 0 53 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0537 0.952393C49.8151 0.952393 52.0537 3.19097 52.0537 5.95239V34.0476C52.0537 36.8091 49.8151 39.0476 47.0537 39.0476H16.2866C14.9772 39.0476 13.7507 38.4067 13.003 37.3318L2.53548 22.2842C1.58036 20.9112 1.58036 19.0888 2.53548 17.7158L13.003 2.66819C13.7507 1.59328 14.9772 0.952393 16.2866 0.952393H47.0537Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6362 27.0165L38.4038 13.0459",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6362 13.0459L38.4038 27.0165",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumpadDelete);
export default __webpack_public_path__ + "static/media/numpad-delete.da246a59590d61228f7b7ae86f1a805b.svg";
export { ForwardRef as ReactComponent };